import { inject, Injectable } from '@angular/core';
import {
  compactNavigation,
  defaultNavigation,
  futuristicNavigation,
  horizontalNavigation,
  footerNavigation,
  socialNavigation
} from './data';

import { cloneDeep } from 'lodash-es';
import { ZopNavigationItem } from '@zopup/zop-ux-core';
import { MockApiService } from '@zopup/zop-core';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
  private readonly _compactNavigation: ZopNavigationItem[] = compactNavigation;
  private readonly _defaultNavigation: ZopNavigationItem[] = defaultNavigation;
  private readonly _futuristicNavigation: ZopNavigationItem[] =
    futuristicNavigation;
  private readonly _horizontalNavigation: ZopNavigationItem[] =
    horizontalNavigation;
  private readonly _footerNavigation: ZopNavigationItem[] =
    footerNavigation;
  private readonly _socialNavigation: ZopNavigationItem[] =
    socialNavigation;


  /**
   * Constructor
   */
  constructor(private _zopMockApiService: MockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._zopMockApiService.onGet('api/common/navigation').reply(() => {
      // Fill compact navigation children using the default navigation
      this._compactNavigation.forEach((compactNavItem) => {
        this._defaultNavigation.forEach((defaultNavItem) => {
          if (defaultNavItem.id === compactNavItem.id) {
            compactNavItem.children = cloneDeep(defaultNavItem.children);
          }
        });
      });

      // Fill futuristic navigation children using the default navigation
      this._futuristicNavigation.forEach((futuristicNavItem) => {
        this._defaultNavigation.forEach((defaultNavItem) => {
          if (defaultNavItem.id === futuristicNavItem.id) {
            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
          }
        });
      });

      // Fill horizontal navigation children using the default navigation
      this._horizontalNavigation.forEach((horizontalNavItem) => {
        this._defaultNavigation.forEach((defaultNavItem) => {
          if (defaultNavItem.id === horizontalNavItem.id) {
            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
          }
        });
      });

      // Return the response
      return [
        200,
        {
          compact: cloneDeep(this._compactNavigation),
          default: cloneDeep(this._defaultNavigation),
          futuristic: cloneDeep(this._futuristicNavigation),
          horizontal: cloneDeep(this._horizontalNavigation),
          footer: cloneDeep(this._footerNavigation),
          social: cloneDeep(this._socialNavigation),
        },

      ];
    });
  }
}
